window.addEventListener("load", () => {
	const targetElement = document.getElementById("ProductGridContainer");
	const observer = new MutationObserver(() => {
		initWishlist(targetElement);
	});
	observer.observe(targetElement, { childList: true, subtree: true });
});

function initWishlist(el) {
	el.querySelectorAll("ul > div").forEach(card => {
		const wishlistElement = card.querySelector(".icon-wishlist-heart-empty");
		const formDropdown = card.querySelector(".spf-product__form select");

		const productId = formDropdown.dataset.proid;
		const variantId = formDropdown.dataset.varid;

		wishlistElement.setAttribute("data-proid", productId);
		wishlistElement.setAttribute("data-varid", variantId);
	});

	// window.HulkappWishlist.init();
	if (typeof HulkappWishlist !== 'undefined') {
		HulkappWishlist._manageCollectionWL();

		const wishlistInterval = setInterval(function () {
		if (typeof HulkappWishlist !== 'undefined') {

			let allHulkWishlistButtons = document.querySelectorAll('[data-wishlist]');

			if (allHulkWishlistButtons.length > 0) {
			allHulkWishlistButtons = Array.from(allHulkWishlistButtons);
			HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');

			// stop interval once elements are found
			clearInterval(wishlistInterval);
			}
		}
		}, 1000);

	}
}

/* === SIB: Wishlist page discount note (added 2026-06-08) === */
(function () {
	function addWishlistDiscountNote() {
		if (window.location.pathname.indexOf('/apps/advanced-wishlist') !== 0) return;
		var main = document.getElementById('MainContent');
		if (!main) return;
		if (document.getElementById('wishlist-discount-note')) return;
		var note = document.createElement('div');
		note.id = 'wishlist-discount-note';
		note.textContent = 'NOTE: Discounts will be added in Cart & Checkout.';
		note.style.cssText = 'margin:16px auto;max-width:var(--page-width,120rem);padding:12px 16px;background:#fff8e1;border:1px solid #f0c000;border-radius:6px;color:#5c4400;font-weight:600;text-align:center;line-height:1.4;';
		main.insertBefore(note, main.firstChild);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', addWishlistDiscountNote);
	} else {
		addWishlistDiscountNote();
	}
	window.addEventListener('load', addWishlistDiscountNote);
})();

/* === SIB: Mobile header account icon (added 2026-06-08) ===
   The search-icon restyle + account-icon show/hide CSS lives in the page <head>
   (snippets/hulkapps-reorder-css.liquid) so it applies on first paint with no flash.
   This script only injects the account <a> between search and cart, and runs
   immediately (it sits at the end of <body>, so #first_menu already exists).
   It auto-disables if a server-rendered account icon is already present, so adding
   the markup directly to sections/header.liquid will simply take over with zero JS. */
(function () {
	function addAccountIcon() {
		var cluster = document.getElementById('first_menu');
		if (!cluster) return false;
		// Already present (either from a previous run or server-rendered in header.liquid)
		if (cluster.querySelector('.header__icon--account-mobile')) return true;
		var cart = cluster.querySelector('.header__icon--cart');
		var a = document.createElement('a');
		a.id = 'sib-mobile-account';
		a.href = '/account/login';
		a.className = 'header__icon header__icon--account header__icon--account-mobile link focus-inset';
		a.setAttribute('aria-label', 'Account');
		a.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="3.7" fill="none" stroke="currentColor" stroke-width="1.7"></circle><path d="M5 20a7 7 0 0 1 14 0" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
		// Place the account icon between the search icon and the cart icon.
		if (cart && cart.parentNode === cluster) {
			cluster.insertBefore(a, cart);
		} else {
			cluster.appendChild(a);
		}
		return true;
	}
	// Run synchronously now; fall back to DOMContentLoaded only if the header isn't ready yet.
	if (!addAccountIcon()) {
		document.addEventListener('DOMContentLoaded', addAccountIcon);
	}
})();
